import React from "react";
import Layout from "./src/components/layout/index.tsx"
export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};